

export const USER_GROUP = {
    USER: 'USER',
    STAFF: 'STAFF',
    ADMIN: 'ADMIN',
}